import React from 'react'
import { makeStyles } from '@material-ui/styles'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import { PGA_COM_HOST } from 'env'
import YourCoaches from './your-coaches'
import SessionsSection from './sessions/sessions-section'
import DiscoverMoreGolf from './discover-more-golf'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(2),
    },
  },
  section: {
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
  },
  btnStyle: {
    width: '100%',
    margin: '25px 0',
  },
}))

export default ({
  students,
  selectedStudent,
  lessonCreditBalances,
  onBookClick,
}) => {
  const student = students.find(({ id }) => id === selectedStudent)
  const classes = useStyles()
  const now = new Date()
  student.coaches.forEach(coach => {
    const filteredById = lessonCreditBalances.filter(({ lessonType }) => {
      return lessonType.coach.id === coach.id
    })
    coach.lessonCreditBalances = filteredById.filter(
      ({ remainingCredits, expiresAt }) => {
        return (
          remainingCredits > 0 && (expiresAt > now.toISOString() || !expiresAt)
        )
      },
    )
  })

  return (
    <Box className={classes.root}>
      <Box className={classes.section}>
        <SessionsSection
          studentId={selectedStudent}
          onBookClick={onBookClick}
        />
      </Box>
      <Box className={classes.section}>
        {!student.coaches.length ? (
          <Button
            className={classes.btnStyle}
            variant="contained"
            color="primary"
            href={`${PGA_COM_HOST}/coaches/search`}
          >
            Find a Coach
          </Button>
        ) : (
          <YourCoaches coaches={student.coaches} />
        )}
      </Box>
      <Box className={classes.section}>
        <DiscoverMoreGolf />
      </Box>
    </Box>
  )
}
